import formatAmount from '~/components/payment/deposit/data/format-amount';

export const formatBonusValue = (bonusValue, remainingValue) => {
	return remainingValue != null ? (remainingValue < bonusValue ? remainingValue : bonusValue) : bonusValue;
};

const getFormattedBonus = (germanRegulatedFranchise, remainingBonusValue, result, userCurrency) => {
	if (germanRegulatedFranchise && remainingBonusValue !== null && result.bonusType === 'DepositBonus') {
		return {
			...result,
			bonusAmount:
				result.bonusAmount &&
				formatAmount(formatBonusValue(result.bonusAmountValue, remainingBonusValue), userCurrency),
			bonusAmountValue: result.bonusAmountValue && formatBonusValue(result.bonusAmountValue, remainingBonusValue),
			maxTotalBonusAmountCurrency:
				result.maxTotalBonusAmountCurrency &&
				formatAmount(formatBonusValue(result.maxTotalBonusAmountValue, remainingBonusValue), userCurrency)
		};
	}
	return result;
};

export default getFormattedBonus;
